var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-box"},[_c('iframe',{ref:"tempHtml",staticClass:"iframe",attrs:{"src":"plugins/download.html","width":"100%","height":"100%","id":"tempHtml","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }